import React, { useState, useMemo } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import * as XLSX from "xlsx";
import { ApiUrl } from "../../../ApiUrl";
import { useNavigate } from "react-router-dom";
import ReactPaginate from "react-paginate";

const AdmAttendanceEntry = () => {
  const navigate = useNavigate();
  const todayDate = new Date().toISOString().split("T")[0];
  const [reportData, setReportData] = useState([]);
  const [fromDate, setFromDate] = useState(todayDate);
  const [toDate, setToDate] = useState(todayDate);
  const [isSearching, setIsSearching] = useState(false);
  const [error, setError] = useState("");
  const [showTable, setShowTable] = useState(false);
  const itemsPerPage = 10;
  const [currentPage, setCurrentPage] = useState(0);

  const handlePageClick = (data) => {
    setCurrentPage(data.selected);
  };

  const offset = currentPage * itemsPerPage;
  const currentItems = useMemo(() => {
    return reportData.slice(offset, offset + itemsPerPage);
  }, [reportData, offset]);
  const pageCount = Math.ceil(reportData.length / itemsPerPage);

  // Fetch the report data based on fromDate and toDate — only runs on Search click
  const handleSearch = async () => {
    const academicYearId = localStorage.getItem("academicSessionId");
    setIsSearching(true);
    setError("");

    if (!academicYearId) {
      console.error("Academic Year ID is not available");
      setError("Academic Year ID is missing");
      setIsSearching(false);
      return;
    }

    let apiUrl = `${ApiUrl.apiurl}LIBRARYBOOK/BookReportlist/?academic_year_id=${academicYearId}`;

    if (fromDate && toDate) {
      apiUrl += `&fromDate=${fromDate}&toDate=${toDate}`;
    } else if (fromDate) {
      apiUrl += `&fromDate=${fromDate}`;
    } else if (toDate) {
      apiUrl += `&toDate=${toDate}`;
    }

    try {
      const response = await fetch(apiUrl);
      const result = await response.json();

      if (
        response.ok &&
        result.message === "success" &&
        result.data.length > 0
      ) {
        setReportData(result.data);
        setShowTable(true);
        setCurrentPage(0);
        setError("");
      } else {
        setReportData([]);
        setShowTable(true);
        setCurrentPage(0);
      }
    } catch (error) {
      console.error("Error fetching report data:", error);
      setError("Error fetching data: " + error.message);
      setReportData([]);
      setShowTable(false);
      setCurrentPage(0);
    } finally {
      setIsSearching(false);
    }
  };

  const exportToExcel = () => {
    if (!reportData || reportData.length === 0) {
      alert("No data available to export!");
      return;
    }
    const exportData = reportData.map((item, index) => ({
      "Sr.No": index + 1,
      "Book Name": item.book_name,
      "Book Code": item.book_code,
      "Accession No.": item.bookBarcode,
      "ISBN No": item.ISBN,
      "No. of Copies": item.no_of_copies,
      Category: item.book_category,
      "Sub Category": item.book_sub_category,
      Publisher: item.publisher,
      "Author Name": item.author,
      "Publish Year": item.publish_year,
      "Library Branch": item.library_branch,
    }));

    const ws = XLSX.utils.json_to_sheet(exportData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Accession Report");
    XLSX.writeFile(wb, "accession_report.xlsx");
  };

  const handleClear = () => {
    setFromDate(todayDate);
    setToDate(todayDate);
    setReportData([]);
    setShowTable(false);
    setError("");
    setCurrentPage(0);
  };

  return (
    <div className="container-fluid ">
      <div className="row">
        <div className="col-12">
          <div className="card p-0">
            <div className="card-body">
              <p
                style={{
                  marginBottom: "0px",
                  textAlign: "center",
                  fontSize: "20px",
                  fontWeight: "700",
                }}
              >
                ACCESSION LIST REPORT
              </p>

              <div className="row mb-2  mt-3 mx-0">
                <div className="col-12 p-2 d-flex flex-wrap gap-2">
                  <button
                    type="button"
                    className="btn btn-primary me-2"
                    style={{ width: "150px" }}
                    onClick={handleSearch}
                    disabled={isSearching}
                  >
                    {isSearching ? "Searching..." : "Search"}
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary me-2"
                    style={{ width: "150px" }}
                    onClick={exportToExcel}
                  >
                    Export to Excel
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary me-2"
                    style={{ width: "150px" }}
                    onClick={handleClear}
                  >
                    Clear
                  </button>
                  <button
                    type="button"
                    className="btn btn-danger me-2"
                    style={{ width: "150px" }}
                    onClick={() => navigate("/admin/dashboard")}
                  >
                    Close
                  </button>
                </div>
              </div>

              {error && (
                <div className="row mx-2">
                  <div className="col-12">
                    <small className="text-danger">{error}</small>
                  </div>
                </div>
              )}

              <div className="row mt-3 mx-2">
                <div className="col-12 custom-section-box">
                  <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center">
                    <div className="row flex-grow-1">
                      <div className="col-12 col-md-3 mb-1">
                        <label htmlFor="from-date" className="form-label ">
                          From Date
                        </label>
                        <input
                          type="date"
                          id="from-date"
                          className="form-control detail"
                          value={fromDate}
                          onChange={(e) => setFromDate(e.target.value)}
                        />
                      </div>
                      <div className="col-12 col-md-3 mb-3">
                        <label htmlFor="to-date" className="form-label">
                          To Date
                        </label>
                        <input
                          type="date"
                          id="to-date"
                          className="form-control detail"
                          value={toDate}
                          onChange={(e) => setToDate(e.target.value)}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {showTable && (
                <>
                  <div className="col-12">
                    <div className="table-responsive">
                      <table className="table table-bordered">
                        <thead>
                          <tr>
                            <th>Sr.No</th>
                            <th>Book Name</th>
                            <th>Book Code</th>
                            <th>Accession No.</th>
                            <th>ISBN No</th>
                            <th>Category</th>
                            <th>Sub Category</th>
                            <th>Publisher</th>
                            <th>Author Name</th>
                            <th>Publish Year</th>
                            <th>Library Branch</th>
                          </tr>
                        </thead>
                        <tbody>
                          {currentItems.length > 0 ? (
                            currentItems.map((item, index) => (
                              <tr key={`${item.book_code}-${index}`}>
                                <td>{offset + index + 1}</td>
                                <td>{item.book_name}</td>
                                <td>{item.book_code}</td>
                                <td>{item.bookBarcode}</td>
                                <td>{item.ISBN}</td>
                                <td>{item.book_category}</td>
                                <td>{item.book_sub_category}</td>
                                <td>{item.publisher}</td>
                                <td>{item.author}</td>
                                <td>{item.publish_year}</td>
                                <td>{item.library_branch}</td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="12" className="text-center">
                                No Data Available
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                  {pageCount > 1 && (
                    <ReactPaginate
                      previousLabel={"Previous"}
                      nextLabel={"Next"}
                      breakLabel={"..."}
                      breakClassName={"page-item"}
                      breakLinkClassName={"page-link"}
                      pageCount={pageCount}
                      marginPagesDisplayed={2}
                      pageRangeDisplayed={5}
                      onPageChange={handlePageClick}
                      containerClassName={"pagination justify-content-center"}
                      pageClassName={"page-item"}
                      pageLinkClassName={"page-link"}
                      previousClassName={"page-item"}
                      previousLinkClassName={"page-link"}
                      nextClassName={"page-item"}
                      nextLinkClassName={"page-link"}
                      activeClassName={"active"}
                    />
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdmAttendanceEntry;
